import { getApiErrorMessage } from "shared/utils";
import type { ApiError } from "shared/utils";

const FALLBACK_MESSAGES: Record<number, string> = {
  400: "This reset link is invalid or expired, or the password doesn't meet requirements.",
  500: "Something went wrong. Please try again later.",
};

const DEFAULT_MESSAGE = "Failed to reset password. Please try again.";

export const getResetPasswordError = (error: ApiError): string | null =>
  getApiErrorMessage(error, FALLBACK_MESSAGES, DEFAULT_MESSAGE);
